import React from 'react';
import myImage from './kachel_schiebedusche.jpg';

const kachelSchiebedusche = () => {
    return (
        <img src={myImage} width="100" height="50" />
    )
}

export default kachelSchiebedusche;



